import {APIGet} from "../api/apiCalls";
import {AppState, TF1AppState, TF1QRPayload} from "../interfaces/interfaces";

const { REACT_APP_RESOLVER_URL } = process.env;

const returnQRCodeParameters = async (): Promise<TF1AppState | null> => {
    // Example Full URL = https://tf1.hosting.sandbox.unitag.io/secretstory/open?codeID=<uuid>
    // Pathname = /secretstory/open
    const pathname = window.location.pathname.trim();
    if (!pathname || pathname.length === 0) {
        throw new Error('no pathname provided');
    }

    const params = new URLSearchParams(window.location.search);
    const codeID = params.get('codeID');
    if (!codeID) {
        throw new Error('no codeID provided');
    }


    // Extract fragments
    const fragments = pathname.split('/');
    if (fragments.length <= 1) {
        throw new Error('incorrect amount of fragments received');
    }

    // Example "secretstory"
    const domain = fragments[1];
    // Example "open"
    const state = fragments[2];

    try {
        // URL encode pathname to check for injection
        const encodedPathname = encodeURI(pathname);
        // Query resolver and get payload from response
        const response = await APIGet<TF1QRPayload>(REACT_APP_RESOLVER_URL + codeID);
        // URI decode components
        const payload: TF1QRPayload = {
            phone: decodeURI(response.parsedBody!.phone),
            message: decodeURI(response.parsedBody!.message),
        }

        // Return object
        return {
            payload: payload,
            domain: domain,
            appState: state === 'open' ? AppState.OPENED : AppState.CLOSED,
        };

    } catch (error) {
        throw new Error('error querying QR code, ' + error);
    }
}

export { returnQRCodeParameters }